import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'jquery/dist/jquery.min';
import 'popper.js/dist/popper.min';
import 'bootstrap/dist/js/bootstrap.min';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

// eslint-disable-next-line no-shadow
import { focus } from './utils/directives';
import { capitalize, currency } from './utils/filters';
import router from './router';
import store from './store/store';
import App from './App';
import { resolveAssetPath } from './utils/asset-util';
import BladeSpinner from './components/BladeSpinner';

import { initializeClientVersionCheck } from './utils/version';

initializeClientVersionCheck();

// Add resolveAssetPath to components and expose BladeSpinner globally for convenience
Vue.mixin({
  methods: {
    resolveAssetPath,
    formatCurrencyString(number) {
      return Math.floor(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  components: {
    BladeSpinner
  }
});

Vue.use(Vuelidate);

Vue.use(Datetime);

Vue.directive('focus', focus);

Vue.filter('capitalize', capitalize);
Vue.filter('currency', currency);

Vue.config.productionTip = false;

// Enables Bootstrap globally
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  filters: { currency },
  components: { App },
  template: '<App/>',
});

/* eslint-disable-next-line no-console */
console.log(process.env);



// WEBPACK FOOTER //
// ./src/main.js